<button mat-flat-button color="primary" [disabled]="disabled" (click)="click()">
  {{ extraAction.name }}
</button>
